import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Card from 'react-bootstrap/Card';
import styles from './ViewFeedbackDetails.module.css';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import useAxiosFetchData from '../../../../hooks/useAxiosFetchData';
import { calculateSLAtimeURL } from '../../../../../constants/constants';
import useAddModal from '../../../../hooks/useAddModal';
import AcceptFeedbackModal from '../../Modal/AcceptFeedbackModal';
import ReactModal from '../../Modal/AddModalCustomer';
import AcceptFeedbackModalBody from '../../Modal/AcceptFeedbackModalBody';

export default function AcceptFeedback({ data, onClose, closeParentModal, isUsedWithModal = false }) {
  const { i18n, t } = useTranslation();
  const { csrfHeaderName, csrfFormTagName, csrfToken } = useSelector((state) => state.csrf);
  const [response, setResponse] = useState(null);
  const [payload, setPayload] = useState(null);
  const [headers, setHeaders] = useState({
    'X-Csrf-Token': csrfToken,
    'Content-Type': 'application/json'
  });
  const { isOpen, val, toggleModal } = useAddModal();
  const [flag, setFlag] = useState(true);
  console.log(data);

  const parseDatafromProps = (dataN) => {
    let tempData = {
      assignmentTime: dataN.receipt.departmentSlaAssignmentList[0].assignmentTime,
      departmentId: dataN.departmentId,
      departmentSlaAssignmentList: [{
        assigneeGroupName: dataN.receipt.departmentSlaAssignmentList[0].assigneeGroupName,
        assignmentTime: dataN.receipt.departmentSlaAssignmentList[0].targetTime,
        departmentSlaId: dataN.receipt.departmentSlaAssignmentList[0].departmentSlaId,
        minuteToCalculate: dataN.receipt.departmentSlaAssignmentList[0].minuteToCalculate,
        step: dataN.receipt.departmentSlaAssignmentList[0].step,
      }],
      departmentSlaEscalationList: dataN.receipt.departmentSlaEscalationList.map(item => ({
        assigneeGroupName: item.assigneeGroupName,
        departmentSlaEscalationId: item.departmentSlaEscalationId,
        escalationStep: item.escalationStep,
        escalationTime: item.escTime,
        minuteToCalculate: item.minuteToCalculate,
      }))
    }
    return tempData;
  }







  const { fetchData: fetchProceedData } = useAxiosFetchData({
    url: calculateSLAtimeURL,
    method: 'post',
    body: payload,
    headers: headers,
    onLoad: false
  });





  const handlerProceedClick = () => {
    fetchProceedData().then((data1) => {
      console.log(data1);
      toggleModal([data1, data]);
    })


  }
  useEffect(() => {
    data && setPayload(parseDatafromProps(data));
    if(payload && isUsedWithModal && flag){
      handlerProceedClick();
      setFlag(false);
    }
  }, [data, isUsedWithModal, payload])


  return (
    <div >
      {
        <AcceptFeedbackModal
          isShowing={isOpen}
          hide={toggleModal}
          val={val}
          onClose={onClose}
        />
        // <ReactModal show={isOpen} handleClose={toggleModal} componentToRender={<AcceptFeedbackModalBody open={isOpen} handleClose={toggleModal} val={val} onClose={onClose}/>}
        // />

      }
      <Card>
        {!isUsedWithModal &&
          <Card.Header className={styles.customHeader}>
            {!isUsedWithModal && <strong><h2>{t('menu.key.feedback.accept')}</h2></strong>}
            {isUsedWithModal && <strong><h2>{t('general.place-holder.select.list')}</h2></strong>}
          </Card.Header>
        }
        <Card.Body>
          <div className="row">
            <div className="col" style={{ fontSsize: "1.8rem", marginBottom: "1rem", }}>
              {!isUsedWithModal && <h2>{t('general.label.proceedText')}</h2>}
              {isUsedWithModal && <h2>{t('Do you wish to continue ?')}</h2>}
            </div>

          </div>
          <div className="row" style={{ "justifyContent": "flex-end", }}>
            <div className="col-auto" style={{ display: "flex", flexDirection: "row", "justifyContent": "flex-end", "alignContent": "flex-end", "alignItems": "flex-end", "gap": "1rem" }}>
              {isUsedWithModal && <button
                type="button"
                className="btn btn-primary"
                style={{ backgroundColor: 'blue' }}
                onClick={() => { closeParentModal() }}
              >
                {/* {t('general.button.proceed')} */}
                Cancel
              </button>}
              <button
                type="button"
                className="btn btn-primary"
                style={{ backgroundColor: 'blue' }}
                onClick={handlerProceedClick}
              >
                {!isUsedWithModal ? t('general.button.proceed') : t("general.button.yes.label")}
              </button>


            </div>
          </div>
        </Card.Body>
      </Card>

    </div>
  )
}
